module.exports = __webpack_public_path__ + "img/06.a0f48fe0.png";